export const SEND_BROADCAST = 'broadcast/SEND';
export const SEND_BROADCAST_SUCCESS = 'broadcast/SEND_SUCCESS';
export const SEND_BROADCAST_ERROR = 'broadcast/SEND_ERROR';
export const RESET_BROADCAST = 'broadcast/RESET';
